import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Form, Input, notification, Select, Row, Col, Spin, Button, Modal, Breadcrumb, Typography } from 'antd';
import { capitalizeString, generateRandomPassword } from '../../redux/actions/customFunction';
import { City, Country, State } from 'country-state-city';
import { formItemLayout, tailFormItemLayout, validatePhoneNumber } from '../../common_functions';

const User = props => {
  const { section, id } = useParams();
  const [userRoles, setUserRoles] = useState([]);
  const [UserStatus, setUserStatus] = useState([]);
  const [stateCities, setStateCities] = useState([]);
  const [user, setUserData] = useState({});
  const [loading, setLoading] = useState(false);
  const [randPass, setUserRandomPass] = useState();
  const [userPassword, setUserPassword] = useState();

  const formRef = useRef();

  const validateOnPhoneCodeChange = value => {
    if (value) {
      formRef.current.setFields([
        {
          name: 'phone',
          errors: [],
          validating: true,
        },
      ]);
      formRef.current.validateFields(['phone']);
    }
  };
  const phoneCode = (
    <Form.Item name="phone_code" initialValue={user.phone_code || 'US-1'} noStyle>
      <Select
        showSearch
        optionFilterProp="children"
        filterOption={(input, option) => option.children.includes(input)}
        style={{
          width: 100,
        }}
        onChange={value => {
          validateOnPhoneCodeChange(value);
          setUserData(prev => ({ ...prev, phone_code: value }));
        }}
      >
        {Country.getAllCountries().map(item => {
          return (
            <Option key={item.isoCode} value={item.isoCode + '-' + item.phonecode}>
              {item.flag} {item.phonecode}
            </Option>
          );
        })}
      </Select>
    </Form.Item>
  );
  useEffect(() => {
    async function fetchData() {
      //ger user roles
      try {
        setLoading(true);
        let userRolesResponse = await props.getUsersData('roles', {
          fields: ['*'],
          sort: '-id',
        });
        setUserRoles(userRolesResponse.data);
        //ger user status fields
        let userStatusResponse = await props.fetchFieldValues('directus_users', {
          fields: ['status'],
        });
        let statusOptions = userStatusResponse.data.meta.options.choices;

        statusOptions = statusOptions.filter(key => {
          // Only Draft, Active and Suspended are selectable
          return ['draft', 'active', 'suspended'].includes(key.value);
        });
        setUserStatus(statusOptions);
        if (section && id) {
          //get user from directus
          await props
            .getUserData('users', {
              fields: '*.*',
              id,
            })
            .then(userResponse => {
              setLoading(false);
              let userItem = !!userResponse && userResponse.data;
              let user_address = userItem.user_address[userItem.user_address.length - 1];
              if (user_address) {
                const user_address_data = {
                  phone: user_address.phone,
                  phone_code: user_address.phone_code,
                  state: user_address.state,
                  city: user_address.city,
                  zip_code: user_address.zip_code,
                  street_address_1: user_address.street_address_1,
                };
                //set user data on edit action
                formRef.current.setFieldsValue({
                  ...userItem,
                  ...user_address_data,
                  role: userItem.role.id,
                });
              }
              setUserData({ ...userResponse.data });
              //set existing password in state
              setUserPassword(userResponse.data.password);
              //set user data on edit action
              formRef.current.setFieldsValue({
                ...userItem,
                role: userItem.role.id,
              });
            })
            .catch(error => {
              setLoading(false);
              Modal.warning({
                title: 'Error',
                content: error.errors[0]['message'],
              });
            });
        } else {
          setLoading(false);
          //generate random password
          const randomPass = generateRandomPassword();
          setUserRandomPass(randomPass);
          //set password
          formRef.current.setFieldsValue({
            password: randomPass,
          });
        }
      } catch (error) {
        setLoading(false);
        Modal.warning({
          title: 'Error',
          content: error.errors[0]['message'],
        });
      }
    }
    fetchData();
  }, []);

  const handleStateChange = state => {
    let cities = City.getCitiesOfState('US', state);
    if (cities.length > 0) {
      //get cities for selected states by state iso code
      setStateCities(cities);
      //onchange reset city dropdown
      formRef.current.setFieldsValue({
        city: '',
      });
    }
  };

  const getRandPassword = State => {
    const randomPass = generateRandomPassword();
    setUserRandomPass(randomPass);
    //set password
    formRef.current.setFieldsValue({
      password: randomPass,
    });
  };

  const validateEmail = (rule, value, callback) => {
    const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (!value || emailPattern.test(value)) {
      callback(); // Pass the validation
    } else {
      callback('Invalid email address');
    }
  };

  let onFinish = async values => {
    setLoading(true);
    const user_address_data = {
      phone: values.phone,
      phone_code: values.phone_code,
      state: values.state,
      city: values.city,
      zip_code: values.zip_code,
      street_address_1: values.street_address_1,
    };
    let userAddress = [user_address_data];
    if (section && id) {
      let allAddress = user.user_address;
      let userAddressId = user.user_address[user.user_address.length - 1]?.id;
      if (userAddressId) {
        userAddress = [...allAddress, { id: userAddressId, ...user_address_data }];
      }
      if (userPassword == values.password) {
        //remove the property from the object:
        delete values.password;
      }
    }
    let saveUser = {
      ...values,
      user_address: userAddress,
    };
    // remove the role field from the values
    if (Object.keys(user).length !== 0) {
      if (user.role.id === saveUser.role) {
        delete saveUser.role;
      }
    }
    await props
      .saveUserData('users', saveUser, user.id)
      .then(response => {
        if (!!response) {
          let msg = user.id ? 'updated' : 'created';
          notification.success({
            message: 'User ' + msg + ' successfully!',
            duration: 2,
          });
          props.history.push('/users');
        }
      })
      .catch(error => {
        notification['error']({
          message: error.errors[0]['message'],
          duration: 2,
        });
      });
    setLoading(false);
  };
  return (
    <Spin spinning={loading} size="large">
      <Row>
        <Col className="app-breadcrumb-col">
          <Breadcrumb items={[{ title: "Users", href: "/users" }, { title: id ? `Edit User` : 'Add User' }]} />
        </Col>
        <Col className="white-paper">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={24}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                {id ? `Edit User: ${id}` : 'Add new user'}
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end"></Col>
          </Row>
          <hr />
          <div className="User">
            <Form ref={formRef} layout="vertical" {...formItemLayout} onFinish={onFinish}>
              <Row gutter={24}>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="first_name"
                    label="First Name"
                    rules={[
                      {
                        whitespace: true,
                        required: true,
                        message: 'First name is required!',
                      },
                    ]}
                  >
                    <Input placeholder="Enter first name" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="last_name"
                    label="Last Name"
                    rules={[
                      {
                        whitespace: true,
                        required: true,
                        message: 'Last name is required!',
                      },
                    ]}
                  >
                    <Input placeholder="Enter last name" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="email"
                    label="Email"
                    rules={[
                      {
                        required: true,
                        message: 'Email is required!',
                      },
                      {
                        validator: validateEmail,
                      },
                    ]}
                  >
                    <Input placeholder="Enter email" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="phone"
                    label="Phone"
                    rules={[
                      {
                        validator: validatePhoneNumber(user?.phone_code || 'US-1'), // Use the imported function
                      },
                    ]}
                    required
                  >
                    <Input addonBefore={phoneCode} placeholder="Enter phone number" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="role"
                    label="User Role"
                    rules={[
                      {
                        required: true,
                        message: 'User role is required!',
                      },
                    ]}
                  >
                    <Select placeholder="Select user role">
                      {userRoles.map(item => {
                        return <Option key={item.id} value={item.id}>{item.name}</Option>;
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="status"
                    label="Status"
                    rules={[
                      {
                        required: true,
                        message: 'Status is required!',
                      },
                    ]}
                  >
                    <Select placeholder="Select status">
                      {UserStatus.map((item, index) => {
                        let statusItem = capitalizeString(item.value);
                        return (
                          <Option key={index} value={item.value}>
                            {statusItem}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="password"
                    label="Password"
                    rules={[
                      {
                        whitespace: true,
                        required: false,
                        message: 'Password is required!',
                      },
                    ]}
                  >
                    {/* <Input/> */}
                    <Input.Password />
                  </Form.Item>
                  <Button className="generate-password" onClick={getRandPassword}>
                    Generate password
                  </Button>
                </Col>
              </Row>
              <Row gutter={24} className="page-header-section" align="middle">
                <Col xs={12}>
                  <Typography.Title level={4} style={{ margin: 0 }}>
                    User Address
                  </Typography.Title>
                </Col>
                <Col xs={12} justify="end"></Col>
              </Row>
              <Row gutter={24}>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="street_address_1"
                    label="Street Address 1"
                    rules={[
                      {
                        //required: true,
                        message: 'Street address is required!',
                      },
                    ]}
                  >
                    <Input placeholder="Enter street address" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="state"
                    label="State"
                    rules={[
                      {
                        message: 'State is required!',
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select state"
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                      onChange={handleStateChange}
                    >
                      <Select.Option key="" value="">Select state</Select.Option>
                      {State.getStatesOfCountry('US').map(item => {
                        return (
                          <Select.Option key={item.isoCode} value={item.isoCode}>
                            {item.name}
                          </Select.Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="city"
                    label="City"
                    rules={[
                      {
                        // required: true,
                        message: 'City is required!',
                      },
                    ]}
                  >
                    {stateCities.length > 0 ? (
                      <Select
                        placeholder="Select city"
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                      >
                        <Select.Option key="" value="">Select city</Select.Option>
                        {stateCities.map(item => (
                          <Select.Option key={item.name} value={item.name}>
                            {item.name}
                          </Select.Option>
                        ))}
                      </Select>
                    ) : (
                      <Input placeholder="Enter city" />
                    )}
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="zip_code"
                    label="Zip Code"
                    rules={[
                      {
                        //required: true,
                        message: 'Zip code is required!',
                      },
                    ]}
                  >
                    <Input placeholder="Enter zip code" />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item {...tailFormItemLayout}>
                <Button className="save-btn" type="primary" htmlType="submit">
                  Save
                </Button>
              </Form.Item>
            </Form>
          </div>
        </Col>
      </Row>
    </Spin>
  );
};
export default User;
